import React from "react";

interface FinalRewardTicketProps {
  width?: string;
  height?: string;
  leftSection?: React.ReactNode;
  rightSection?: React.ReactNode;
  fillColor?: string;
}

const FinalRewardTicket: React.FC<FinalRewardTicketProps> = ({
  width = "474",
  height = "136",
  fillColor = "#CCCCCC",
  leftSection,
  rightSection,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 444 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_2274_5678)">
        <mask id="path-1-inside-1_2274_5678" fill="white">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.00003 16.3477C2.00003 10.8248 6.47718 6.34766 12 6.34766H432C437.523 6.34766 442 10.8248 442 16.3477V18.7192C436.029 18.7192 431.189 22.98 431.189 28.2358C431.189 33.4917 436.029 37.7524 442 37.7524V115.313C436.029 115.313 431.189 119.573 431.189 124.829C431.189 130.085 436.029 134.346 442 134.346V141C442 146.523 437.523 151 432 151H12C6.47717 151 2.00003 146.523 2.00003 141L2 134.346C7.97065 134.346 12.8108 130.085 12.8108 124.829C12.8108 119.573 7.97065 115.313 2 115.313L2.00003 38.2285C7.97057 38.2284 12.8106 33.9677 12.8106 28.7119C12.8106 23.4561 7.97057 19.1954 2.00003 19.1953V16.3477Z"
          />
        </mask>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.00003 16.3477C2.00003 10.8248 6.47718 6.34766 12 6.34766H432C437.523 6.34766 442 10.8248 442 16.3477V18.7192C436.029 18.7192 431.189 22.98 431.189 28.2358C431.189 33.4917 436.029 37.7524 442 37.7524V115.313C436.029 115.313 431.189 119.573 431.189 124.829C431.189 130.085 436.029 134.346 442 134.346V141C442 146.523 437.523 151 432 151H12C6.47717 151 2.00003 146.523 2.00003 141L2 134.346C7.97065 134.346 12.8108 130.085 12.8108 124.829C12.8108 119.573 7.97065 115.313 2 115.313L2.00003 38.2285C7.97057 38.2284 12.8106 33.9677 12.8106 28.7119C12.8106 23.4561 7.97057 19.1954 2.00003 19.1953V16.3477Z"
          fill="#06A3B0"
        />
        <path
          d="M442 18.7192V19.7192H443V18.7192H442ZM442 37.7524H443V36.7524H442V37.7524ZM442 115.313V116.313H443V115.313H442ZM442 134.346H443V133.346H442V134.346ZM2.00003 141H3.00003H2.00003ZM2 134.346V133.346H0.999996L1 134.346L2 134.346ZM2 115.313H1L1 116.313H2V115.313ZM2.00003 38.2285L2.00001 37.2285L1.00003 37.2285L1.00003 38.2285H2.00003ZM2.00003 19.1953H1.00003V20.1953L2.00001 20.1953L2.00003 19.1953ZM12 5.34766C5.92489 5.34766 1.00003 10.2725 1.00003 16.3477H3.00003C3.00003 11.3771 7.02946 7.34766 12 7.34766V5.34766ZM432 5.34766H12V7.34766H432V5.34766ZM443 16.3477C443 10.2725 438.075 5.34766 432 5.34766V7.34766C436.971 7.34766 441 11.3771 441 16.3477H443ZM443 18.7192V16.3477H441V18.7192H443ZM432.189 28.2358C432.189 23.6483 436.458 19.7192 442 19.7192V17.7192C435.601 17.7192 430.189 22.3117 430.189 28.2358H432.189ZM442 36.7524C436.458 36.7524 432.189 32.8234 432.189 28.2358H430.189C430.189 34.16 435.601 38.7524 442 38.7524V36.7524ZM443 115.313V37.7524H441V115.313H443ZM432.189 124.829C432.189 120.242 436.458 116.313 442 116.313V114.313C435.601 114.313 430.189 118.905 430.189 124.829H432.189ZM442 133.346C436.458 133.346 432.189 129.417 432.189 124.829H430.189C430.189 130.753 435.601 135.346 442 135.346V133.346ZM443 141V134.346H441V141H443ZM432 152C438.075 152 443 147.075 443 141H441C441 145.971 436.971 150 432 150V152ZM12 152H432V150H12V152ZM1.00003 141C1.00003 147.075 5.92488 152 12 152V150C7.02945 150 3.00003 145.971 3.00003 141H1.00003ZM1 134.346L1.00003 141H3.00003L3 134.346L1 134.346ZM11.8108 124.829C11.8108 129.417 7.54198 133.346 2 133.346V135.346C8.39931 135.346 13.8108 130.753 13.8108 124.829H11.8108ZM2 116.313C7.54198 116.313 11.8108 120.242 11.8108 124.829H13.8108C13.8108 118.905 8.39931 114.313 2 114.313V116.313ZM1.00003 38.2285L1 115.313H3L3.00003 38.2285H1.00003ZM11.8106 28.7119C11.8106 33.2994 7.54189 37.2284 2.00001 37.2285L2.00004 39.2285C8.39924 39.2284 13.8106 34.636 13.8106 28.7119H11.8106ZM2.00001 20.1953C7.54189 20.1954 11.8106 24.1244 11.8106 28.7119H13.8106C13.8106 22.7878 8.39924 18.1954 2.00004 18.1953L2.00001 20.1953ZM1.00003 16.3477V19.1953H3.00003V16.3477H1.00003Z"
          fill="#BCA685"
          mask="url(#path-1-inside-1_2274_5678)"
        />
      </g>
      <rect
        x="30.2344"
        y="20"
        width="388.065"
        height="117"
        rx="9"
        fill="white"
        stroke="#06A3B0"
        stroke-width="2"
      />
      <line
        x1="40.9189"
        y1="38.2397"
        x2="313.892"
        y2="38.2397"
        stroke="#06A3B0"
        stroke-width="2"
      />
      <line
        x1="40.6553"
        y1="124"
        x2="211.968"
        y2="124"
        stroke="#06A3B0"
        stroke-width="2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M442 16.3477C442 10.8248 437.523 6.34766 432 6.34766H310.648V151H432C437.523 151 442 146.523 442 141L442 134.346C436.029 134.346 431.189 130.085 431.189 124.829C431.189 119.573 436.029 115.313 442 115.313V37.7524C436.029 37.7524 431.189 33.4917 431.189 28.2358C431.189 22.98 436.029 18.7192 442 18.7192L442 16.3477Z"
        fill="#A41E35"
      />
      <path d="M168.92 137L305.285 20H413.15V137H168.92Z" fill="#FF8736" />
      <path d="M175.948 137L312.313 19H420.178V137H175.948Z" fill="#FF6200" />
      <g filter="url(#filter1_i_2274_5678)">
        <ellipse
          cx="14.4323"
          cy="79.3476"
          rx="5.94595"
          ry="6.34763"
          fill="white"
        />
      </g>
      <g filter="url(#filter2_i_2274_5678)">
        <ellipse
          cx="431.189"
          cy="79.3476"
          rx="5.94595"
          ry="6.34763"
          fill="white"
        />
      </g>
      <ellipse
        cx="312.811"
        cy="6.34763"
        rx="5.94595"
        ry="6.34763"
        fill="white"
      />
      <ellipse
        cx="311.73"
        cy="150.348"
        rx="5.94595"
        ry="6.34763"
        fill="white"
      />
      <line
        x1="41.6553"
        y1="39"
        x2="41.6553"
        y2="125"
        stroke="#06A3B0"
        stroke-width="2"
      />
      <path
        d="M394.226 35.0464L395.221 38.561H398.206L395.803 40.3917L396.787 43.7932L394.226 41.7139L391.664 43.7932L392.648 40.3917L390.246 38.561H393.231L394.226 35.0464ZM394.226 27.2603L391.664 36.3008H383.64L390.171 41.2844L387.694 49.8617L394.226 44.5616L400.768 49.8617L398.28 41.2844L404.811 36.3008H396.787L394.226 27.2603Z"
        fill="white"
      />
      <path
        d="M252.649 48.7713L253.221 50.7902H254.935L253.555 51.8419L254.121 53.796L252.649 52.6015L251.177 53.796L251.743 51.8419L250.362 50.7902H252.077L252.649 48.7713ZM252.649 44.2983L251.177 49.4919H246.568L250.32 52.3548L248.897 57.2821L252.649 54.2374L256.407 57.2821L254.978 52.3548L258.73 49.4919H254.121L252.649 44.2983Z"
        fill="#06A3B0"
      />
      <path
        d="M228.929 66.7713L229.5 68.7902H231.215L229.835 69.8419L230.4 71.796L228.929 70.6015L227.457 71.796L228.023 69.8419L226.642 68.7902H228.357L228.929 66.7713ZM228.929 62.2983L227.457 67.4919H222.848L226.6 70.3548L225.177 75.2821L228.929 72.2374L232.687 75.2821L231.258 70.3548L235.01 67.4919H230.4L228.929 62.2983Z"
        fill="#06A3B0"
      />
      <path
        d="M189.324 102.771L189.896 104.79H191.611L190.23 105.842L190.796 107.796L189.324 106.601L187.853 107.796L188.418 105.842L187.038 104.79H188.753L189.324 102.771ZM189.324 98.2983L187.853 103.492H183.243L186.995 106.355L185.572 111.282L189.324 108.237L193.082 111.282L191.653 106.355L195.405 103.492H190.796L189.324 98.2983Z"
        fill="#06A3B0"
      />
      <path
        d="M209.601 84.7713L210.173 86.7902H211.888L210.507 87.8419L211.073 89.796L209.601 88.6015L208.129 89.796L208.695 87.8419L207.315 86.7902H209.029L209.601 84.7713ZM209.601 80.2983L208.129 85.4919H203.52L207.272 88.3548L205.849 93.2821L209.601 90.2374L213.359 93.2821L211.93 88.3548L215.682 85.4919H211.073L209.601 80.2983Z"
        fill="#06A3B0"
      />
      <path
        d="M394.226 71.0464L395.221 74.561H398.206L395.803 76.3917L396.787 79.7932L394.226 77.7139L391.664 79.7932L392.648 76.3917L390.246 74.561H393.231L394.226 71.0464ZM394.226 63.2603L391.664 72.3008H383.64L390.171 77.2844L387.694 85.8617L394.226 80.5616L400.768 85.8617L398.28 77.2844L404.811 72.3008H396.787L394.226 63.2603Z"
        fill="white"
      />
      <path
        d="M395.983 108.046L396.978 111.561H399.963L397.56 113.392L398.544 116.793L395.983 114.714L393.421 116.793L394.405 113.392L392.002 111.561H394.988L395.983 108.046ZM395.983 100.26L393.421 109.301H385.397L391.928 114.284L389.451 122.862L395.983 117.562L402.524 122.862L400.037 114.284L406.568 109.301H398.544L395.983 100.26Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_2274_5678"
          x="0"
          y="6.34766"
          width="444"
          height="148.652"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2274_5678"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2274_5678"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_i_2274_5678"
          x="8.48633"
          y="73"
          width="11.8921"
          height="16.6953"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_2274_5678"
          />
        </filter>
        <filter
          id="filter2_i_2274_5678"
          x="425.243"
          y="73"
          width="11.8921"
          height="16.6953"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_2274_5678"
          />
        </filter>
      </defs>
      <foreignObject
        x="45"
        y="60"
        width="180"
        height="60"
        className="left-section"
      >
        {leftSection}
      </foreignObject>
      <foreignObject
        x="280"
        y="60"
        width="100"
        height="50"
        className="right-section"
      >
        {rightSection}
      </foreignObject>
    </svg>
  );
};

export default FinalRewardTicket;
